import script from "./applicant-detail.vue?vue&type=script&setup=true&lang=js"
export * from "./applicant-detail.vue?vue&type=script&setup=true&lang=js"

import "./applicant-detail.vue?vue&type=style&index=0&id=7bfab97a&lang=scss"

const __exports__ = script;

export default __exports__